import { useNavigate } from "react-router-dom";

import { AdminButton } from "@/components/admin/button";
import { Card, CardBody, CardHead } from "@/components/admin/card";
import { AdminIcon } from "@/components/admin/icon";

interface Option {
	k: "totp" | "sms" | "email" | "whatsapp";
	icn: "qr" | "phone" | "mail" | "chat";
	title: string;
	desc: string;
	available: boolean;
}

const OPTIONS: Option[] = [
	{
		k: "totp",
		icn: "qr",
		title: "Application authenticator (TOTP)",
		desc: "Google Authenticator, Authy, 1Password · recommandé pour Super Admin",
		available: true,
	},
	{
		k: "sms",
		icn: "phone",
		title: "SMS",
		desc: "Code envoyé via NEXAH (à venir)",
		available: false,
	},
	{
		k: "email",
		icn: "mail",
		title: "Email",
		desc: "Code envoyé sur votre email pro (à venir)",
		available: false,
	},
	{
		k: "whatsapp",
		icn: "chat",
		title: "WhatsApp Business",
		desc: "Code via WhatsApp (à venir)",
		available: false,
	},
];

export function MfaMethodPickerPage() {
	const navigate = useNavigate();

	return (
		<div>
			<div className="crumbs" style={{ marginBottom: 14, fontSize: 12 }}>
				<a
					className="root"
					style={{ cursor: "pointer" }}
					onClick={() => navigate("/profil/securite")}
				>
					Sécurité
				</a>
				<span className="sep">
					<AdminIcon n="chevR" s={10} />
				</span>
				<span className="here">Ajouter une méthode 2FA</span>
			</div>

			<Card style={{ maxWidth: 720 }}>
				<CardHead
					title="Choisissez votre méthode de vérification"
					sub="Vous pourrez en ajouter d'autres ensuite. Une seule est utilisée par défaut."
				/>
				<CardBody>
					<div className="method-list" style={{ border: "none" }}>
						{OPTIONS.map((o) => (
							<div
								key={o.k}
								className={"method-item " + (o.k === "totp" ? "selected" : "")}
								style={{
									opacity: o.available ? 1 : 0.5,
									cursor: o.available ? "pointer" : "not-allowed",
								}}
								onClick={() =>
									o.available && navigate("/profil/securite/2fa/totp")
								}
								data-testid={`mfa-pick-${o.k}`}
							>
								<div className="icon">
									<AdminIcon n={o.icn} s={18} />
								</div>
								<div className="body">
									<div className="t">{o.title}</div>
									<div className="d">{o.desc}</div>
								</div>
								<div className="check">
									{o.k === "totp" && <AdminIcon n="check" s={12} />}
								</div>
							</div>
						))}
					</div>

					<div
						style={{
							display: "flex",
							gap: 8,
							justifyContent: "flex-end",
							marginTop: 16,
						}}
					>
						<AdminButton
							variant="ghost"
							onClick={() => navigate("/profil/securite")}
						>
							<AdminIcon n="chevL" s={14} />
							Retour
						</AdminButton>
						<AdminButton
							variant="primary"
							onClick={() => navigate("/profil/securite/2fa/totp")}
							data-testid="mfa-continue-totp"
						>
							Continuer avec TOTP
							<AdminIcon n="arrow" s={14} c="#fff" />
						</AdminButton>
					</div>
				</CardBody>
			</Card>
		</div>
	);
}
